type EventWithUrls = {
    request?: { url?: string };
    breadcrumbs?: Array<{ data?: Record<string, unknown> }>;
};

const redactToken = (value: string) => value.replace(/([?&]token=)[^&#]*/g, "$1[Filtered]");

export function redactInvitationToken<T extends EventWithUrls>(event: T): T {
    if (event.request?.url) event.request.url = redactToken(event.request.url);
    event.breadcrumbs?.forEach(({ data }) => {
        if (!data) return;
        ["url", "from", "to"].forEach((key) => {
            const value = data[key];
            if (typeof value === "string") data[key] = redactToken(value);
        });
    });
    return event;
}
